import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import * as moment from 'moment';
import { defaultStore, initializeDefaultStore, loadState, combinedReducer } from '../common/redux-state'
import { storeUrl } from '../common/redux-state/actions/listing';
import { ProviderApp } from './components/app';
import { storeFilterOptions, upsertFilter } from '../common/redux-state/actions/filters';
import { Sort } from '../common/components/sort-options';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

var locationSearch = document.getElementById("location-entry-js");
var query = locationSearch.getAttribute("data-query");
var parentID = locationSearch.getAttribute("data-get-children-pages");
var searchUrl = locationSearch.getAttribute("data-location-search-url");
defaultStore.dispatch(storeFilterOptions("/api/SearchResult/GetLocationFilters") as any);

if (parseInt(parentID) > 0) {
    defaultStore.dispatch(upsertFilter("LocationParent", parentID));
    defaultStore.dispatch(upsertFilter("sort", Sort.AtoZ.toString()));
} else {
    defaultStore.dispatch(upsertFilter("QueryValue", encodeURIComponent(query)));
}

defaultStore.dispatch(storeUrl("/api/SearchResult/GetLocations?"));
// Store the API URL last so that it doesn't unnecessarily get pinged.
const savedState = loadState("locationState");
let updatedStore;

var defaultSearchBox = query;
if (savedState) {
    savedState.filtersState.currentMonth = moment(savedState.filtersState.currentMonth);
    updatedStore = createStore(combinedReducer, savedState, applyMiddleware(thunk));
    defaultSearchBox = savedState.filtersState.filters["QueryValue"];
}

initializeDefaultStore(updatedStore ? updatedStore : defaultStore);
var prevQuery = sessionStorage.getItem("prevQueryString")
if (prevQuery != query && updatedStore) {
    sessionStorage.setItem("prevQueryString", query);
    updatedStore.dispatch(upsertFilter("QueryValue", encodeURIComponent(query)));
    defaultSearchBox = query;
}

var prevLocation = sessionStorage.getItem("prevLocation")
if (prevLocation != parentID && updatedStore && parseInt(parentID) > 0) {
    sessionStorage.setItem("prevLocation", parentID);
    updatedStore.dispatch(upsertFilter("LocationParent", parentID));
}
render(<Provider store={updatedStore ? updatedStore : defaultStore}>
    <ProviderApp searchBoxDefault={defaultSearchBox} hospitalSearch={parseInt(parentID) > 0 ? true : false} locationSearchUrl={searchUrl} />
</Provider>, locationSearch);
